var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { observable, computed, action } from 'mobx';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';

// TODO COMPARE: delete this store and remove it from other files
let CreatorsComparisonStore = (_class = class CreatorsComparisonStore {
  constructor() {
    _initializerDefineProperty(this, "creatorsComparison", _descriptor, this);
    _initializerDefineProperty(this, "shouldAddDefault", _descriptor2, this);
    _initializerDefineProperty(this, "defaultCreatorInComparison", _descriptor3, this);
    _initializerDefineProperty(this, "firstCreatorProvider", _descriptor4, this);
    _initializerDefineProperty(this, "addToComparison", _descriptor5, this);
    _initializerDefineProperty(this, "removeFromComparison", _descriptor6, this);
    _initializerDefineProperty(this, "isCreatorInComparison", _descriptor7, this);
    _initializerDefineProperty(this, "handleSelect", _descriptor8, this);
    _initializerDefineProperty(this, "resetComparison", _descriptor9, this);
    _initializerDefineProperty(this, "addDefaultCreatorInComparison", _descriptor0, this);
    _initializerDefineProperty(this, "openComparisonOnNewTab", _descriptor1, this);
  }
  get comparisonMode() {
    return this.creatorsComparison.length > 0;
  }
  setComparison(comparison) {
    this.creatorsComparison = comparison;
  }
  makeComparisonPageUrl() {
    const qs = this.creatorsComparison.map(({
      provider,
      id
    }) => `&creators=${provider}:${id}`).join('');
    return `/compare/creators?comparing=creators${qs}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "creatorsComparison", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "shouldAddDefault", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "defaultCreatorInComparison", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "firstCreatorProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "comparisonMode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "comparisonMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setComparison", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setComparison"), _class.prototype), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addToComparison", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return creator => {
      if (this.creatorsComparison.length === 0) {
        this.firstCreatorProvider = creator.provider;
      }
      if (this.defaultCreatorInComparison && creator.id !== this.defaultCreatorInComparison.id && !this.isCreatorInComparison(this.defaultCreatorInComparison) && this.shouldAddDefault) {
        return this.setComparison([...this.creatorsComparison, this.defaultCreatorInComparison, creator]);
      }
      this.setComparison([...this.creatorsComparison, creator]);
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "removeFromComparison", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ({
      id
    }) => {
      const newComparison = this.creatorsComparison.filter(creator => creator.id !== id);
      if (newComparison.length === 0) {
        this.firstCreatorProvider = null;
      }
      return this.setComparison(newComparison);
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isCreatorInComparison", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ({
      creatorId
    }) => !!find(propEq('id', creatorId))(this.creatorsComparison);
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "handleSelect", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ({
      creator
    }) => {
      const shouldAddToComparison = !this.isCreatorInComparison({
        creatorId: creator.id
      });
      shouldAddToComparison ? this.addToComparison(creator) : this.removeFromComparison(creator);
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "resetComparison", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      this.firstCreatorProvider = null;
      return this.creatorsComparison = [];
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "makeComparisonPageUrl", [action], Object.getOwnPropertyDescriptor(_class.prototype, "makeComparisonPageUrl"), _class.prototype), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "addDefaultCreatorInComparison", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return creator => {
      this.shouldAddDefault = !!creator;
      if (creator) this.defaultCreatorInComparison = {
        ...creator,
        id: creator.creatorId
      };
      return;
    };
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "openComparisonOnNewTab", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return () => {
      if (!this.creatorsComparison.length) return;
      const url = this.makeComparisonPageUrl();
      window.open(url, '_blank');
    };
  }
}), _class);
export default new CreatorsComparisonStore();